module.exports = __webpack_public_path__ + "img/resourcesbg4.168273ed.png";